import { SetMetadata } from '@nestjs/common';

export const PUBLIC_KEY = 'PUBLIC';

export const Public = (options?: { passThrough?: boolean }) => SetMetadata(PUBLIC_KEY, options || true);
